import styled from 'styled-components';
export var ButtonStyling = styled.button.withConfig({
  displayName: "Buttonstyles__ButtonStyling",
  componentId: "pantheon__wlcgc0-0"
})(["font-size:16px;border-radius:3px;min-height:42px;min-width:144px;background-color:#979797;color:white;cursor:pointer;border:none;&:hover{background-color:#454545;}"]);